import {Injectable} from "@angular/core";
import {AbstractHttpService} from "./AbstractHttpService";
import {Bioma} from "../../../domain/Bioma";

@Injectable()
export class BiomaHttpService  extends AbstractHttpService<Bioma>{
    url = '/api/bioma';
}
